var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronIconRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 19,
    viewBox: "0 0 11 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7420_413)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.4027 18.6025C-0.1342 18.0725 -0.1342 17.2132 0.4027 16.6832L7.68046 9.5L0.402701 2.3168C-0.134199 1.7868 -0.134199 0.927498 0.402701 0.397498C0.939701 -0.132502 1.8103 -0.132502 2.34727 0.397498L10.5973 8.5404C11.1342 9.07035 11.1342 9.92965 10.5973 10.4596L2.34727 18.6025C1.8103 19.1325 0.939699 19.1325 0.4027 18.6025Z",
    fill: "#A39F9C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7420_413"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 19,
    fill: "white",
    transform: "translate(11 19) rotate(-180)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronIconRight);
export default __webpack_public_path__ + "static/media/chevron-icon-right.09665a00de6baffa7969de34e16782c9.svg";
export { ForwardRef as ReactComponent };